var _path, _rect, _rect2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrigorifero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3D8F4"
    },
    d: "M391.837,478.302H120.163V28.735c0-11.542,9.356-20.898,20.898-20.898h229.878 c11.542,0,20.898,9.356,20.898,20.898V478.302z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120.163,
    y: 265.404,
    style: {
      fill: "#3D9AE2"
    },
    width: 271.673,
    height: 24.555
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.163,
    y: 453.486,
    style: {
      fill: "#3D9AE2"
    },
    width: 271.673,
    height: 24.816
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 147.853,
    y: 50.155,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.673,
    height: 133.747
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.853,
    y: 332.278,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.673,
    height: 52.245
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.731,
    y: 71.053,
    style: {
      fill: "#FFFFFF"
    },
    width: 106.58,
    height: 134.792
  })), /*#__PURE__*/React.createElement("rect", {
    x: 249.731,
    y: 71.053,
    style: {
      fill: "#3D9AE2"
    },
    width: 24.555,
    height: 134.792
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M370.939,0H141.061c-15.844,0-28.735,12.89-28.735,28.735v457.404h287.347V28.735C399.673,12.89,386.783,0,370.939,0z  M141.061,15.673h229.878c7.202,0,13.061,5.859,13.061,13.061v228.833H128V28.735C128,21.532,133.859,15.673,141.061,15.673z  M128,282.122v-8.882h256v8.882H128z M384,297.796v147.853H128V297.796H384z M128,470.465v-9.143h256v9.143H128z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 339.592,
    y: 496.327,
    width: 52.245,
    height: 15.673
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120.163,
    y: 496.327,
    width: 52.245,
    height: 15.673
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M364.147,63.216H241.894v150.465h122.253V63.216z M257.567,78.89h8.882v119.118h-8.882V78.89z M348.473,198.008h-66.351 V78.89h66.351V198.008z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrigorifero);
export default __webpack_public_path__ + "static/media/frigorifero.3451f5141da622d1712642523cb24cdc.svg";
export { ForwardRef as ReactComponent };